import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
	resultLabel: {
		id: 'comment-result.label',
		defaultMessage: 'Comment',
		description: 'Comment label',
	},
});
